import { Outlet } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import SiteNav from "./SiteNav";

export default function SiteLayout() {
  const { isAuthenticated } = useAdminAuth();

  return (
    <div className={`site-shell${isAuthenticated ? "" : " site-shell--no-nav"}`}>
      {isAuthenticated ? <SiteNav /> : null}
      <Outlet />
    </div>
  );
}
